import gql from 'graphql-tag';

export default gql`
	query CheckCountry($latitude: String!, $longitude: String!) {
		checkCountry(lat: $latitude, lng: $longitude) {
			available
		}
	}
`;
